import { FC, PropsWithChildren, useCallback } from 'react';
import { useNavigate } from 'react-router';
import { useValidateSelectedProducts } from './useValidateSelectedProducts';
import { useValidateBundles } from './useValidateBundles';
import { useValidateFinanceModels } from './useValidateFinanceModels';
import { Modal } from '@/components/modal/Modal';
import { useModal } from '@/components/modal/useModal';
import { Card } from '@/components/sections/Card';
import { useValidateStockParameters } from './useValidateStockParameters';
import { CatalogueNavigationContext, CatalogueStep } from './catalogueHooks';

export const CatalogueNavigationProvider: FC<PropsWithChildren> = ({ children }) => {
  const navigate = useNavigate();
  const validateSelectedProducts = useValidateSelectedProducts();
  const validateBundles = useValidateBundles();
  const validateFinanceModels = useValidateFinanceModels();
  const validateStockParameters = useValidateStockParameters();

  const modalProps = useModal<string>();

  const navigateAndValidate = useCallback(
    (link: string, step?: CatalogueStep) => {
      let errorMessage: string = '';

      if (step) {
        if (step === CatalogueStep.SELECT_PRODUCTS) {
          errorMessage = validateSelectedProducts();
        }

        if (step === CatalogueStep.SELECT_FINANCE_MODELS) {
          //errorMessage = validateFinanceModels();
        }

        if (step === CatalogueStep.SELECT_BUNDLES) {
          errorMessage = validateBundles();
        }

        if (step === CatalogueStep.SELECT_STOCK_PARAMETERS) {
          errorMessage = validateStockParameters();
        }
      }

      if (errorMessage) {
        modalProps.open(errorMessage);
      } else {
        navigate(link);
      }
    },
    [
      navigate,
      open,
      validateBundles,
      validateFinanceModels,
      validateSelectedProducts,
      validateStockParameters
    ]
  );

  return (
    <CatalogueNavigationContext.Provider value={navigateAndValidate}>
      <Modal className="md:max-w-xl" {...modalProps}>
        <Card className="flex w-full flex-col gap-2 p-5 whitespace-pre-wrap">
          <Modal.Controls {...modalProps}>
            <span className="text-lg font-mid">Info</span>
          </Modal.Controls>
          {modalProps.props}
        </Card>
      </Modal>
      {children}
    </CatalogueNavigationContext.Provider>
  );
};
